import { prop, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { Rate } from "../../rates/_types/rate";

export class WorkerRate extends Resource {
    public override type = 'workerRates';
    
    @prop()    
    @required()
    public workerId!: string;
    public worker!: Worker;

    @prop()
    public rateId!: string;
    public rate!: Rate;    

    
    @prop()
    public normalServiceAllowed: boolean = true;

    @prop()
    public guardServiceAllowed: boolean = true;

}

